import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_tree_add",
  "use": "lc_tree_add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" class=\"design-iconfont\" id=\"lc_tree_add\">\r\n  <g stroke=\"#999\" fill=\"none\" fill-rule=\"evenodd\">\r\n    <g stroke-linecap=\"round\">\r\n      <path d=\"M4 0.5L4 7.5\" transform=\"translate(4 4)\" />\r\n      <path transform=\"rotate(90 4 8)\" d=\"M4 0.5L4 7.5\" />\r\n    </g>\r\n    <path d=\"M7 0.5A6.5 6.5 0 1 0 7 13.5A6.5 6.5 0 1 0 7 0.5Z\" transform=\"translate(1 1)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol